import * as React from 'react';

import type {STEP_QUESTIONNAIRE_SECTIONS_RESPONSE} from 'src/types/crm';

import {useDispatch} from 'react-redux';
import * as reduxApi from 'src/utils/redux-api-v2';

import {CircularLoader} from '@spaced-out/ui-design-system/lib/components/CircularLoader';


const GetSpecficSections = ({
  jobId,
  stageId,
  stepId,
  children,
  loaderComponent,
}: {
  jobId: number;
  stageId: number;
  stepId: number;
  children: (
    sections: Array<STEP_QUESTIONNAIRE_SECTIONS_RESPONSE>,
  ) => React.ReactNode;
  loaderComponent: React.ReactNode;
}) => {
  const dispatch = useDispatch();
  const [sections, setSections] = React.useState<any>(null);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    if (!sections) {
      setIsLoading(true);
      dispatch(
        reduxApi.get(
          `api/step-questionnaire-sections?jobId=${jobId}&stageId=${stageId}&stepId=${stepId}`,
          {},
          {
            apiPath: '/trmapi/',
          },
        ),
      )
        // @ts-expect-error - TS2339 - Property 'then' does not exist on type 'ThunkAction<any>'. | TS7006 - Parameter 'res' implicitly has an 'any' type.
        .then((res) => {
          setSections(res);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [jobId, stageId, stepId]);
  if (isLoading) {
    return loaderComponent ? loaderComponent : <CircularLoader />;
  }
  if (!sections) {
    return null;
  }
  return children(sections);
};

export default GetSpecficSections;
